import axios from "axios";
import * as types from "../mutation-types";

export const state = {
  api_keys: null,
  payments: [],
  deposits: []
};

// getters
export const getters = {
  api_keys: state => {
    return state.api_keys;
  },
  payments: state => {
    return state.payments;
  },
  deposits: state => {
    return state.deposits;
  }
};

export const mutations = {
  [types.FETCH_APIKEYS_SUCCESS](state, { api_keys }) {
    state.api_keys = api_keys;
  },
  [types.FETCH_APIKEYS_FAILURE](state) {
    state.api_keys = null;
  },
  [types.FETCH_WHITELABEL_PAYMENTS_SUCCESS](state, { payments }) {
    state.payments = payments;
  },
  [types.FETCH_WHITE_LABEL_FAILURE](state) {
    state.payments = [];
  },
  [types.FETCH_ACCOUNTS_DEPOSITS_SUCCESS](state, { deposits }) {
    state.deposits = deposits;
  },
  [types.FETCH_ACCOUNTS_DEPOSITS_FAILURE](state) {
    state.deposits = [];
  }
};

export const actions = {
  async fetchApiKeys({ commit }) {
    try {
      const { data } = await axios.get("/api/v1/apikeys/list");
      commit(types.FETCH_APIKEYS_SUCCESS, { api_keys: data });
    } catch (e) {
      commit(types.FETCH_APIKEYS_FAILURE);
      throw e;
    }
  },
  async fetchPayments({ commit }) {
    try {
      const { data } = await axios.get("/api/v1/whitelabel/payments");
      commit(types.FETCH_WHITELABEL_PAYMENTS_SUCCESS, { payments: data });
    } catch (e) {
      commit(types.FETCH_WHITE_LABEL_FAILURE);
    }
  },
  async fetchAccountsDeposits({ commit }) {
    try {
      const { data } = await axios.get("/api/v1/whitelabel/accounts");
      commit(types.FETCH_ACCOUNTS_DEPOSITS_SUCCESS, { deposits: data });
    } catch (e) {
      commit(types.FETCH_ACCOUNTS_DEPOSITS_FAILURE);
      throw e;
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/whitelabel.js